import styled from "styled-components"

interface TransitionTimeout {
  appear: number
  enter: number
  exit: number
}

interface TransitionProps {
  timeout: TransitionTimeout
}

export const StyledTransition = styled.div<TransitionProps>`
  .transitionFeed-appear {
    opacity: 0.01;
    margin-top: 100px;
  }

  .transitionFeed-appear.transitionFeed-appear-active {
    opacity: 1;
    margin-top: 0px;
    ${({timeout}) => `transition: opacity ${timeout.appear}ms ease, margin-top ${timeout.appear / 2}ms ease;`}
  }

  .transitionFeed-enter {
    opacity: 0.01;
    margin-top: 100px;
  }

  .transitionFeed-enter.transitionFeed-enter-active {
    opacity: 1;
    margin-top: 0px;
    ${({timeout}) => `transition: opacity ${timeout.enter}ms ease, margin-top ${timeout.appear / 2}ms ease;`}
  }

  .transitionFeed-exit {
    opacity: 1;
  }

  .transitionFeed-exit.transitionFeed-exit-active {
    opacity: 0.01;
    ${({timeout}) => `transition: opacity ${timeout.exit}ms ease;`}
  }
`
